import { ReactComponent as ConsumptionSVG } from "./../../../assets/consuption-icon.svg";
import Toggle from "../../elements/Toggle";
import { useIntl } from "react-intl";

export function LPoint({
  labels,
  linesCount,
  isBentPipe,
  changeBentPipe = () => {},
  disabled,
}) {
  const { formatMessage } = useIntl();

  let typeId = "end-point";
  let showBentPipeToggle = false;

  if (linesCount === 2) {
    showBentPipeToggle = true;
    typeId = isBentPipe ? "bent-pipe-point" : "l-point";
  }

  return (
    <div>
      <div className="pipeline-name">
        {formatMessage({ id: labels[typeId].type })}
      </div>
      <div className="pipeline-properties-item">
        {showBentPipeToggle && (
          <div className="pipeline-properties-row">
            <div className="small-text">
              {formatMessage({ id: labels["bent-pipe-point"].toggle })}
            </div>
            <Toggle
              current={isBentPipe}
              onChange={changeBentPipe}
              disabled={disabled}
            />
          </div>
        )}
      </div>
    </div>
  );
}

export function TPoint({ labels }) {
  const { formatMessage } = useIntl();

  return (
    <div className="pipeline-name">
      {labels ? formatMessage({ id: labels["t-point"].type }) : "t-point"}
    </div>
  );
}

export function SystemElPoint({ labels, type }) {
  const { formatMessage } = useIntl();
  let labelId = labels?.[type]?.type ?? labels?.[type]?.title;
  return (
    <div className="pipeline-name">
      {labelId ? formatMessage({ id: labelId }) : type}
    </div>
  );
}

export const SprinklerPoint = ({ labels, sprinklerWaterflow }) => {
  const { formatMessage, formatNumber } = useIntl();

  return (
    <PipelineItem
      icon={<ConsumptionSVG />}
      label={
        labels
          ? formatMessage({ id: labels["sprinkler-point"].consumption })
          : "consumption"
      }
      text={formatNumber(sprinklerWaterflow)}
      unit="m<sup>3</sup>/h"
    />
  );
};

export const ConnectionPoint = ({
  labels,
  type,
  hasDripline = false,
  changeDripline = () => {},
  disabled,
}) => {
  const { formatMessage } = useIntl();

  return (
    <div>
      <div className="pipeline-name">
        {type === "dripline-point"
          ? labels
            ? formatMessage({ id: labels["dripline-point"].type })
            : "dripline-point"
          : labels
          ? formatMessage({ id: labels["end-point"].type })
          : "end-point"}
      </div>
      <div className="pipeline-properties-item">
        <div className="pipeline-properties-row">
          <div className="small-text">
            {labels
              ? formatMessage({ id: labels["dripline-point"].toggle })
              : "dripline"}
          </div>
          <Toggle
            current={hasDripline}
            onChange={changeDripline}
            disabled={disabled}
          />
        </div>
      </div>
    </div>
  );
};

export const WaterTapPoint = ({ labels, type }) => {
  const { formatMessage } = useIntl();
  return (
    <div>
      <div className="pipeline-name">
        {type === "water-tap-point"
          ? labels
            ? formatMessage({ id: labels["water-tap-point"].type })
            : "water-tap-point"
          : labels
          ? formatMessage({ id: labels["end-point"].type })
          : "end-point"}
      </div>
    </div>
  );
};

export const PipelineItem = ({ icon, label, text, unit, textInfo }) => {
  return (
    <div className="pipeline-properties-item icon">
      <div className="pipeline-properties-row">
        <div className="item-icon">
          {icon}
          <div className="small-text">{label}</div>
        </div>
        <div className="item-text-wrap">
          <div className="text-wrap">
            <span className="item-text">{text}</span>
            {unit && (
              <span
                className="small-text"
                dangerouslySetInnerHTML={{ __html: unit }}
              ></span>
            )}
          </div>
          {textInfo && (
            <div
              className="small-text text-info"
              dangerouslySetInnerHTML={{ __html: textInfo }}
            ></div>
          )}
        </div>
      </div>
    </div>
  );
};
